import CryptoJS from "crypto-js";
const key = CryptoJS.enc.Utf8.parse("18457234084562362938475612098745"); // 32 characters for AES-256
const iv = CryptoJS.enc.Utf8.parse("2693406186954376"); // 16 characters for AES

export const encrypt = (text) => {
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const decrypt = (encryptedText) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedText = CryptoJS.enc.Utf8.stringify(decrypted);
    return decryptedText;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};



export function getPriceBasedOnDay(priceForWeekday, priceForWeekend) {
  const today = new Date();
  const dayOfWeek = today.getDay();

  if (dayOfWeek === 0 || dayOfWeek === 6) {
    return formatValues(priceForWeekend);
  } else {
    return formatValues(priceForWeekday);
  }
}

export function discountMaxPrice(priceForWeekday, priceForWeekend) {
  const today = new Date();
  const dayOfWeek = today.getDay();

  if (dayOfWeek === 0 || dayOfWeek === 6) {
    return priceForWeekend * 0.9;  // Apply 10% discount for weekend
  } else {
    return priceForWeekday * 0.9;  // Apply 10% discount for weekday
  }
}



export function checkAvailabilityAndCalculatePrice(discountAmount) {
  if (typeof discountAmount !== 'number') {
    discountAmount = parseFloat(discountAmount) || 0;
  }
  const formattedDiscount = discountAmount.toFixed(2);
  return formattedDiscount;
}

export function formatRating(rating) {
  if (rating % 1 !== 0 && Math.round(rating * 10) / 10 !== rating) {
    return Math.floor(rating * 10) / 10;
  }
  return rating;
}

export function formatValues(rating) {
  if (rating % 1 !== 0) {
    return Math.round(rating * 100) / 100; // Round to 2 decimal places
  }
  return rating;
}

export function description(eng, heb, lang , words = 35) {
  const des = lang === "he" ? heb : eng;
  return des ? des.slice(0, words) + "..." : des;
}

export function descriptionList(eng, heb, lang , words = 35) {
  const des = lang === "he" ? heb : eng;
  return des ? des.slice(0, words)  : des;
}


export function Long_Des(eng, heb, lang , words = 500) {
  const des = lang === "he" ? heb : eng;
  return words <= 500 ? des.slice(0, words) + "..." : des;
}



